import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unlocked",
  "use": "icon-unlocked-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-unlocked\"><path d=\"M8 9c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5m0-1c-.8 0-1.5.7-1.5 1.5S7.2 11 8 11s1.5-.7 1.5-1.5S8.8 8 8 8\" /><path d=\"M12 5h-1V4c0-1.7-1.3-3-3-3-.8 0-1.5.3-2 .8l.6.8c.3-.4.8-.6 1.4-.6 1.1 0 2 .9 2 2v1H4c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m1 7c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h8c.6 0 1 .4 1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol